import { mainSiteUrl } from '@/mocks/categories';

export default function SafetySection() {
  return (
    <section id="safety" className="py-16 md:py-20 relative overflow-hidden bg-background-900">
      <div className="absolute inset-0 bg-gradient-to-br from-background-900 via-background-950 to-foreground-950"></div>
      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-300 text-xs font-semibold tracking-wide uppercase mb-4">
              / Safety Center
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight max-w-xl">
              How <span className="text-primary-400">Kakobuy Spreadsheet</span> Keeps You Safe
            </h2>
            <p className="text-white/70 text-sm md:text-base mt-6 leading-relaxed max-w-lg">
              Shopping through spreadsheets can be risky without the right guardrails. The <strong className="text-white/90">kakobuyspreadsheet</strong> safety framework was designed by experienced buyers who have navigated thousands of transactions. We verify seller credentials, track link freshness, and maintain a community-driven alert system to protect you from common pitfalls.
            </p>
            <p className="text-white/60 text-sm mt-4 leading-relaxed max-w-lg">
              Every link in our <strong className="text-white/80">kakobuy spreadsheet</strong> passes through a multi-step verification pipeline: community feedback analysis, link health monitoring, and periodic manual review. When a seller's reputation drops or a link goes dead, our system flags it within hours — not days.
            </p>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white text-sm font-semibold hover:bg-white/25 transition-all duration-200 cursor-pointer"
            >
              Read Our Safety Policy
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>

          <div className="flex-1 w-full">
            <div className="bg-background-50/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/10">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-6">
                Our Verification Process
              </h3>
              <div className="space-y-5">
                {[
                  {
                    step: '01',
                    title: 'Community Feedback Analysis',
                    desc: 'Aggregated reviews and ratings from real buyers inform seller trust scores.',
                  },
                  {
                    step: '02',
                    title: 'Link Health Monitoring',
                    desc: 'Automated crawlers check every spreadsheet link for availability and redirects.',
                  },
                  {
                    step: '03',
                    title: 'Manual Review',
                    desc: 'Our editorial team periodically audits high-traffic sellers in the kakobuy spreadsheet.',
                  },
                  {
                    step: '04',
                    title: 'Alert System',
                    desc: 'Flagged sellers and broken links are surfaced immediately through our notification pipeline.',
                  },
                ].map((item) => (
                  <div key={item.step} className="flex gap-4">
                    <span className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-500/20 text-primary-300 text-xs font-bold">
                      {item.step}
                    </span>
                    <div>
                      <h4 className="text-sm font-semibold text-white">{item.title}</h4>
                      <p className="text-xs text-white/60 mt-1 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}